"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var Handle = function HandleForRangeInput(_ref) {
  var _classNames;

  var handleId = _ref.handleId,
      currentHandlePosition = _ref.currentHandlePosition,
      storedValue = _ref.storedValue,
      classPrefix = _ref.classPrefix,
      active = _ref.active,
      fieldData = _ref.fieldData;
  var handleClass = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__handle"), !active), (0, _defineProperty2["default"])(_classNames, "".concat(classPrefix, "__handle--active"), active), _classNames));
  var suffix = fieldData.control.options.handleSuffix || '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    ref: handleId,
    className: handleClass,
    style: {
      left: "".concat(currentHandlePosition, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classPrefix, "__value")
  }, storedValue, suffix));
};

Handle.propTypes = {
  handleId: _propTypes["default"].shape({}).isRequired,
  currentHandlePosition: _propTypes["default"].number.isRequired,
  storedValue: _propTypes["default"].number.isRequired,
  active: _propTypes["default"].bool.isRequired,
  classPrefix: _propTypes["default"].string.isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].any.isRequired
  }).isRequired
};
var _default = Handle;
exports["default"] = _default;